enum Difficulty {
    Easy = 0.85,
    Medium = 1,
    Hard = 1.08,
    Impoppable = 1.2,
}

export default Difficulty;